import { render, staticRenderFns } from "./agentComplaintFeedback.vue?vue&type=template&id=9af56898&scoped=true&"
import script from "./agentComplaintFeedback.vue?vue&type=script&lang=js&"
export * from "./agentComplaintFeedback.vue?vue&type=script&lang=js&"
import style0 from "./agentComplaintFeedback.vue?vue&type=style&index=0&id=9af56898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af56898",
  null
  
)

export default component.exports